module.exports = __webpack_public_path__ + "static/media/logo-small.a46cf6c8.svg";